import { AddXLevels } from '../utils/AddXLevel';
import { pipelineData } from './dummyPipeline2';

export const data = [
  {
    sender: 'user',
    type: 'text',
    content: 'Hi there!',
    timestamp: '2025-06-19T10:00:00Z',
  },
  {
    sender: 'copilot',
    type: 'text',
    content: 'Hello! How can I assist you today?',
    timestamp: '2025-06-19T10:00:02Z',
  },
  {
    sender: 'user',
    type: 'text',
    content: 'I want to read a CSV file, perform a data quality check, and save the results to S3.',
    timestamp: '2025-06-19T10:00:05Z',
  },
  {
    sender: 'copilot',
    type: 'text',
    content: 'Got it! You can achieve that using the following set of blocks:',
    timestamp: '2025-06-19T10:00:08Z',
  },
  {
    sender: 'copilot',
    type: 'blocks',
    content: [
      { previousNodes: [], currentNode: { nodeId: 'dndnode_1750309810001', nodeName: 'ReadCSV' } },
      {
        previousNodes: [],
        currentNode: { nodeId: 'dndnode_1750309810002', nodeName: 'ReadCSVAws' },
      },
      {
        previousNodes: [
          { nodeId: 'dndnode_1750309810001', nodeName: 'ReadCSV' },
          { nodeId: 'dndnode_1750309810002', nodeName: 'ReadCSVAws' },
        ],
        currentNode: { nodeId: 'dndnode_1750309810003', nodeName: 'Join' },
      },
      {
        previousNodes: [{ nodeId: 'dndnode_1750309810003', nodeName: 'Join' }],
        currentNode: {
          nodeId: 'dndnode_1750309810004',
          nodeName: 'Filter',
        },
      },
      {
        previousNodes: [{ nodeId: 'dndnode_1750309810004', nodeName: 'Filter' }],
        currentNode: { nodeId: 'dndnode_1750309810005', nodeName: 'WriteCsvAWS' },
      },
    ],
    timestamp: '2025-06-19T10:00:10Z',
  },
  {
    sender: 'user',
    type: 'text',
    content: 'Could you create a workflow using these blocks?',
    timestamp: '2025-06-19T10:00:12Z',
  },
  {
    sender: 'copilot',
    type: 'text',
    content: 'Sure! Here’s the workflow I’ve put together for you:',
    timestamp: '2025-06-19T10:00:14Z',
  },
  {
    sender: 'copilot',
    type: 'pipeline',
    content: AddXLevels(pipelineData),
    timestamp: '2025-06-19T10:00:16Z',
  },
  {
    sender: 'copilot',
    type: 'text',
    content: `Let me know if you need anything else. I'm here to help! 😊`,
    timestamp: '2025-06-19T10:00:14Z',
  },
];
